import React, { useState } from 'react';
import { Block } from "@randajan/jet-react/dom/block";

import "./Profile.scss";
import { LogoutButton } from '../LogoutButton/LogoutButton';
import { Medailon } from '../Medailon/Medailon';
import { userBeam } from '../../../config/bifrost';
import { useBeam } from '@randajan/bifrost/client/react';
import { DateTime } from '../../../elements/DateTime/DateTime';
import { Caption } from '@randajan/jet-react/dom/caption';
import { Form, Field, Switch } from "@randajan/jet-react/dom/form";
import { Subscriptions } from '../../Subscriptions/Subscriptions';
import { createQueue } from '@randajan/queue';
import { Czk } from '../../../elements/Czk/Czk';

const updateProfile = createQueue(data=>userBeam.act.update(data), {
    softMs: 5000,
    pass: "last"
});


export const Profile = () => {
    const { data: profile } = useBeam(userBeam);

    if (!profile) { return null; }

    const { name, subIsActive, credit, subStartAt, subEndAt } = profile;


    return (
        <section className="Profile slab" caption={name}>
            <div className="header">
                <Medailon {...profile} />
                <Caption className="name">{name}</Caption>
            </div>

            <div className="grid">
                <Form className="fields" caption="Informace" rawput={profile} output={profile} onOutput={form=>updateProfile(form.getOutput())}>
                    <Field className="name" name="name" label={"Jméno a příjmení"} maxLength={32}/>
                    <Field className="email" name="email" label={"E-mail"} maxLength={32}/>
                    <Switch className="notifikace" name="consentNotify" label={"E-mailové notifikace"}/>
                </Form>
                {
                    <Block className="subscription" caption={""}>
                        {
                            !subIsActive ? null : <Block className="interval" caption={"Předplacené období"}>
                                <DateTime value={subStartAt} />
                                <span> - </span>
                                <DateTime value={subEndAt} />
                            </Block>
                        }
                        {
                            !credit ? null : <Block className="credit" caption={"Kredit z předchozích plateb"}>
                                <Czk value={credit}/>
                            </Block>
                        }
                    </Block>
                }
            </div>



            <Subscriptions credit={credit} />
            <LogoutButton />
        </section>
    )
}
